/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-11-28 14:53:18.

export interface CreateBankDto {
    fullName: string;
    shortName: string;
    streetName: string;
    streetNumber: string;
    city: string;
    postalCode: string;
    municipality: string;
    country: string;
    mbr: string;
    pib: string;
    countryOfIncorporation: string;
    swift: string;
    bic: string;
}

export interface AddClientsPricelistByIdRequestDto {
    accountIds: string[];
    pricelistId: string;
}

export interface WebBooleanResponse {
    result: boolean; problemResponseData?: ProblemResponseData|null;
}

export interface CreateMasterAgentAccountRequestDto {
    id: string;
    name: string;
    isActive: boolean;
    accountType: AccountType;
    bban: string;
    purposeOfAccountDescription: string;
    currency: string;
    accountStatus: AccountStatus;
    canBeBlocked: boolean;
    account: string;
    recipientIban: string;
    correspondentBankSwift: string;
    correspondentBankName: string;
    recipientName: string;
}

export interface WebResponseEntity<T> {
    result: T; problemResponseData?: ProblemResponseData|null;
}

export interface UpdateMasterAgentAccountRequestDto {
    id: string;
    name: string;
    isActive: boolean;
    accountType: AccountType;
    bban: string;
    purposeOfAccountDescription: string;
    currency: string;
    accountStatus: AccountStatus;
    canBeBlocked: boolean;
    bankConnectionType: string;
    account: string;
}

export interface CreateAttributeRequestDto {
    display: string;
    key: string;
    isRange: boolean;
    serviceTypeId: string;
    attributeValues: { [index: string]: string };
}

export interface WebUUIDResponse {
    result: string; problemResponseData?: ProblemResponseData|null;
}

export interface ActivatePricelistRequestDto {
    pricelistId: string;
}

export interface CreatePricelistRequestDto {
    name: string;
    description: string;
    pricelistType: PricelistType;
    validFromDateTime: DateAsString;
    validToDateTime: DateAsString;
    createdByName: string;
    serviceTypeId: string;
}

export interface ClosePricelistRequestDto {
    pricelistId: string;
    reason: string;
}

export interface DeactivatePricelistRequestDto {
    pricelistId: string;
}

export interface FinishCreatingPricelistRequestDto {
    pricelistId: string;
    username: string;
}

export interface FinishFormingPricelistRequestDto {
    pricelistId: string;
    username: string;
}

export interface FinishSettingPricelistDefinitionRequestDto {
    pricelistId: string;
    username: string;
}

export interface GetFilteredPricelistsRequestDto {
    serviceTypeId: string;
    name: string;
    activeFrom: DateAsString;
    activeTo: DateAsString;
    bank: string;
    referenceNumber: string;
    pricelistStateType: PricelistStateType;
    pricelistType: PricelistType;
    paginationData: PaginationRequestCommon;
    sortBy: string;
    ascending: boolean;
}

export interface HardDeletePricelistRequestDto {
    pricelistId: string;
}

export interface SoftDeletePricelistRequestDto {
    pricelistId: string;
}

export interface UpdatePricelistRequestDto {
    pricelistId: string;
    name: string;
    pricelistType: PricelistType;
    description: string;
    validFromDateTime: DateAsString;
    validToDateTime: DateAsString;
    updatedByName: string;
}

export interface UpdatePricelistDefinitionDto {
    pricelistId: string;
    allowedAttributes: FilteredAttributeForDefinitionRequestDto[];
    username: string;
}

export interface UpdatePricelistItemsRequestDto {
    pricelistId: string;
    pricelistItemDtos: CreatePricelistItemRequestDto[];
    username: string;
}

export interface RejectPricelistRequestDto {
    pricelistId: string;
    reason: string;
}

export interface ReturnPricelistForUpdateRequestDto {
    pricelistId: string;
}

export interface VerifyPricelistRequestDto {
    pricelistId: string;
}

export interface BankDto {
    id: string;
    fullName: string;
    shortName: string;
    streetName: string;
    streetNumber: string;
    city: string;
    postalCode: string;
    municipality: string;
    country: string;
    mbr: string;
    pib: string;
    countryOfIncorporation: string;
    swift: string;
    bic: string;
}

export interface WebListResponseEntity<T> {
    result: T[]; problemResponseData?: ProblemResponseData|null;
}

export interface WebResponseObject<T> extends WebResponseBase {
    result: T;
}

export interface GetAllMasterAgentAccountsResponseDto {
    masterAgentAccountCommons: MasterAgentAccountCommon[];
}

export interface GetAllAccountsByBicResponseDto {
    accounts: MasterAgentAccountCommon[];
}

export interface GetAllBanksResponseDto {
    bankCommons: BankDto[];
}

export interface GetAllMasterAgentBanksResponseDto {
    banks: BankDto[];
}

export interface GetMasterAgentAccountResponseDto {
    masterAgentAccountCommon: MasterAgentAccountCommon;
}

export interface UpdateMasterAgentAccountResponseDto {
    masterAgent: MasterAgentAccountCommon;
}

export interface GetAllAttributesResponseDto {
    attributeCommons: AttributeCommon[];
}

export interface GetAllAttributesByServiceTypeIdResponseDto {
    attributeCommons: AttributeCommon[];
}

export interface GetAttributeResponseDto {
    attributeCommon: AttributeCommon;
}

export interface GetAllPricelistsResponseDto {
    pricelists: PricelistCommon[];
}

export interface PaginationRequestCommon {
    currentPage: number;
    itemsPerPage: number;
}

export interface GetFilteredPricelistsResponseDto {
    pricelists: PricelistCommon[];
    totalCount: number;
}

export interface GetPricelistResponseDto {
    pricelist: PricelistCommon;
}

export interface FilteredAttributeForDefinitionRequestDto {
    attributeId: string;
    allowedValuesId: string[];
}

export interface CreatePricelistItemRequestDto {
    attributeInstanceDtos: CreateAttributeInstanceRequestDto[];
    amountFrom: number;
    amountTo: number;
    ordersFrom: number;
    ordersTo: number;
    startTime: DateAsString;
    endTime: DateAsString;
    fixedFee: number;
    percentageFee: number;
    minimalFee: number;
    maximalFee: number;
    taxRate: number;
}

export interface ProblemResponseData extends Serializable {
    error: boolean;
    problems: ProblemBase[];
}

export interface WebResponseBase extends Serializable {
    problemResponseData: ProblemResponseData;
}

export interface ResponseEntity<T> {
    result: T;
    problemResponseData?: ProblemResponseData|null;
}

export interface MasterAgentAccountCommon {
    id: string;
    name: string;
    isActive: boolean;
    accountType: AccountType;
    bban: string;
    bank: BankDto;
    purposeOfAccountDescription: string;
    currency: string;
    accountStatus: AccountStatus;
    canBeBlocked: boolean;
    recipientIban: string;
    correspondentBankSwift: string;
    correspondentBankName: string;
    recipientName: string;
    account: string;
    createdOn: DateAsString;
    modifiedBy: string;
    modifiedOn: DateAsString;
    pricelistIds: string[];
    version: number;
}

export interface AttributeCommon {
    id: string;
    display: string;
    key: string;
    isRange: boolean;
    attributeValues: AttributeValueCommon[];
}

export interface PricelistCommon {
    id: string;
    name: string;
    description: string;
    validFromDateTime: DateAsString;
    createdAtDateTime: DateAsString;
    updatedAtDateTime: DateAsString;
    updatedByName: string;
    pricelistStateType: string;
    reason: string;
    pricelistAllowedActions: string[];
    pricelistEditSnapshot: PricelistEditSnapshotCommon;
    pricelistDefinition: PricelistDefinitionCommon;
    pricelistItems: PricelistItemCommon[];
    pricelistStateChanges: PricelistStateChangeCommon[];
    assignedToMasterAgentAccount: string;
}

export interface CreateAttributeInstanceRequestDto {
    rangeStart: number;
    rangeEnd: number;
    attributeId: string;
    attributeValueId: string;
}

export interface ProblemBase extends Serializable {
    problemCode: number;
    applicationOrigin: string;
    exceptionCode: string;
    message: string;
    details: string;
    type: string;
}

export interface Serializable {
}

export interface AttributeValueCommon {
    id: string;
    display: string;
    value: string;
    attributeId: string;
    pricelistDefinitionIds: string[];
}

export interface PricelistEditSnapshotCommon {
    id: string;
    name: string;
    description: string;
    validFromDateTime: DateAsString;
    updatedAtDateTime: DateAsString;
    pricelistId: string;
}

export interface PricelistDefinitionCommon {
    id: string;
    pricelistAttributes: AttributeCommon[];
    attributeAllowedValues: AttributeValueCommon[];
    pricelistId: string;
}

export interface PricelistItemCommon {
    id: string;
    amountFrom: number;
    amountTo: number;
    ordersFrom: number;
    ordersTo: number;
    startTime: DateAsString;
    endTime: DateAsString;
    fixedFee: number;
    percentageFee: number;
    minimalFee: number;
    maximalFee: number;
    taxRate: number;
    pricelistId: string;
    attributeInstanceCommons: AttributeInstanceCommon[];
}

export interface PricelistStateChangeCommon {
    id: string;
    pricelistId: string;
    pricelistStateType: PricelistStateType;
    stateChangeDateTime: DateAsString;
    rejectionReason: string;
    closingReason: string;
}

export interface HttpEntity<T> {
    headers: { [index: string]: string[] };
    body: T;
}

export interface AttributeInstanceCommon {
    id: string;
    rangeStart: number;
    rangeEnd: number;
    attributeValue: AttributeValueCommon;
    attribute: AttributeCommon;
}

export interface HttpClient<O> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: O; }): RestResponse<R>;
}

export class RestApplicationClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /financial-service-provider/attribute/create
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistAttributeController.addPricelistAttribute
     */
    addPricelistAttribute(createAttributeRequestDto: CreateAttributeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/attribute/create`, data: createAttributeRequestDto, options: options });
    }

    /**
     * HTTP GET /financial-service-provider/attribute/get-all
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistAttributeController.getAll
     */
    getAll$GET$financialserviceprovider_attribute_getall(options?: O): RestResponse<WebResponseEntity<GetAllAttributesResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`financial-service-provider/attribute/get-all`, options: options });
    }

    /**
     * HTTP GET /financial-service-provider/attribute/get-all-by-service-type-id/{ID}
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistAttributeController.getAllByServiceTypeId
     */
    getAllByServiceTypeId(ID: string, options?: O): RestResponse<WebResponseEntity<GetAllAttributesByServiceTypeIdResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`financial-service-provider/attribute/get-all-by-service-type-id/${ID}`, options: options });
    }

    /**
     * HTTP GET /financial-service-provider/attribute/get/{ID}
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistAttributeController.getPricelistAttribute
     */
    getPricelistAttribute(ID: string, options?: O): RestResponse<WebResponseEntity<GetAttributeResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`financial-service-provider/attribute/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/banks/create
     * Java method: com.europoint.financialserviceprovider.web.controllers.BankController.create
     */
    create$POST$financialserviceprovider_banks_create(createBankRequestDto: CreateBankDto, options?: O): RestResponse<WebResponseEntity<BankDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/banks/create`, data: createBankRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/banks/delete
     * Java method: com.europoint.financialserviceprovider.web.controllers.BankController.delete
     */
    delete(queryParams: { bic: string; }, options?: O): RestResponse<WebResponseEntity<boolean>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/banks/delete`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /financial-service-provider/banks/find-by-bic
     * Java method: com.europoint.financialserviceprovider.web.controllers.BankController.findByBic
     */
    findByBic(queryParams: { bic: string; }, options?: O): RestResponse<WebResponseEntity<BankDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`financial-service-provider/banks/find-by-bic`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /financial-service-provider/banks/get-all
     * Java method: com.europoint.financialserviceprovider.web.controllers.BankController.getAll
     */
    getAll$GET$financialserviceprovider_banks_getall(options?: O): RestResponse<WebListResponseEntity<BankDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`financial-service-provider/banks/get-all`, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/master-agent-account/add-pricelist-by-id
     * Java method: com.europoint.financialserviceprovider.web.controllers.MasterAgentAccountController.addPricelistByClientId
     */
    addPricelistByClientId(addClientsPricelistByIdRequestDto: AddClientsPricelistByIdRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/master-agent-account/add-pricelist-by-id`, data: addClientsPricelistByIdRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/master-agent-account/create
     * Java method: com.europoint.financialserviceprovider.web.controllers.MasterAgentAccountController.create
     */
    create$POST$financialserviceprovider_masteragentaccount_create(createMasterAgentAccountRequestDto: CreateMasterAgentAccountRequestDto, options?: O): RestResponse<WebResponseEntity<any>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/master-agent-account/create`, data: createMasterAgentAccountRequestDto, options: options });
    }

    /**
     * HTTP GET /financial-service-provider/master-agent-account/get-all
     * Java method: com.europoint.financialserviceprovider.web.controllers.MasterAgentAccountController.getAll
     */
    getAll$GET$financialserviceprovider_masteragentaccount_getall(options?: O): RestResponse<WebResponseEntity<GetAllMasterAgentAccountsResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`financial-service-provider/master-agent-account/get-all`, options: options });
    }

    /**
     * HTTP GET /financial-service-provider/master-agent-account/get-all-accounts-by-bic/{bic}
     * Java method: com.europoint.financialserviceprovider.web.controllers.MasterAgentAccountController.getAllAccountsByBic
     */
    getAllAccountsByBic(bic: string, options?: O): RestResponse<WebResponseEntity<GetAllAccountsByBicResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`financial-service-provider/master-agent-account/get-all-accounts-by-bic/${bic}`, options: options });
    }

    /**
     * HTTP GET /financial-service-provider/master-agent-account/get-all-banks
     * Java method: com.europoint.financialserviceprovider.web.controllers.MasterAgentAccountController.getAllBanks
     */
    getAllBanks(options?: O): RestResponse<WebResponseEntity<GetAllBanksResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`financial-service-provider/master-agent-account/get-all-banks`, options: options });
    }

    /**
     * HTTP GET /financial-service-provider/master-agent-account/get-all-banks-for-master-agent
     * Java method: com.europoint.financialserviceprovider.web.controllers.MasterAgentAccountController.getAllMasterAgentBanks
     */
    getAllMasterAgentBanks(options?: O): RestResponse<WebResponseEntity<GetAllMasterAgentBanksResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`financial-service-provider/master-agent-account/get-all-banks-for-master-agent`, options: options });
    }

    /**
     * HTTP GET /financial-service-provider/master-agent-account/get/{ID}
     * Java method: com.europoint.financialserviceprovider.web.controllers.MasterAgentAccountController.getClientById
     */
    getClientById(ID: string, options?: O): RestResponse<WebResponseEntity<GetMasterAgentAccountResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`financial-service-provider/master-agent-account/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/master-agent-account/update
     * Java method: com.europoint.financialserviceprovider.web.controllers.MasterAgentAccountController.update
     */
    update(updateMasterAgentAccountRequestDto: UpdateMasterAgentAccountRequestDto, options?: O): RestResponse<WebResponseEntity<UpdateMasterAgentAccountResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/master-agent-account/update`, data: updateMasterAgentAccountRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/platform-provider-pricelist/reject
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistPlatformProviderController.rejectPricelist
     */
    rejectPricelist(rejectPricelistRequestDto: RejectPricelistRequestDto, options?: O): RestResponse<WebResponseEntity<any>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/platform-provider-pricelist/reject`, data: rejectPricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/platform-provider-pricelist/return-for-update
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistPlatformProviderController.returnPricelistForUpdate
     */
    returnPricelistForUpdate(returnPricelistForUpdateRequestDto: ReturnPricelistForUpdateRequestDto, options?: O): RestResponse<WebResponseEntity<any>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/platform-provider-pricelist/return-for-update`, data: returnPricelistForUpdateRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/platform-provider-pricelist/verify
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistPlatformProviderController.verifyPricelist
     */
    verifyPricelist(verifyPricelistRequestDto: VerifyPricelistRequestDto, options?: O): RestResponse<WebResponseEntity<any>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/platform-provider-pricelist/verify`, data: verifyPricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/pricelist/activate
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.activatePricelist
     */
    activatePricelist(activatePricelistRequestDto: ActivatePricelistRequestDto, options?: O): RestResponse<WebResponseEntity<any>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/pricelist/activate`, data: activatePricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/pricelist/close
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.closePricelist
     */
    closePricelist(closePricelistRequestDto: ClosePricelistRequestDto, options?: O): RestResponse<WebResponseEntity<any>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/pricelist/close`, data: closePricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/pricelist/create
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.addPricelist
     */
    addPricelist(createPricelistRequestDto: CreatePricelistRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/pricelist/create`, data: createPricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/pricelist/deactivate
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.deactivatePricelist
     */
    deactivatePricelist(deactivatePricelistRequestDto: DeactivatePricelistRequestDto, options?: O): RestResponse<WebResponseEntity<any>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/pricelist/deactivate`, data: deactivatePricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/pricelist/finish-creating
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.finishCreatingPricelist
     */
    finishCreatingPricelist(finishCreatingPricelistRequestDto: FinishCreatingPricelistRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/pricelist/finish-creating`, data: finishCreatingPricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/pricelist/finish-forming
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.finishFormingPricelist
     */
    finishFormingPricelist(finishFormingPricelistRequestDto: FinishFormingPricelistRequestDto, options?: O): RestResponse<WebResponseEntity<any>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/pricelist/finish-forming`, data: finishFormingPricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/pricelist/finish-setting-pricelist-definition
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.finishSettingPricelistDefinition
     */
    finishSettingPricelistDefinition(finishSettingPricelistDefinitionRequestDto: FinishSettingPricelistDefinitionRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/pricelist/finish-setting-pricelist-definition`, data: finishSettingPricelistDefinitionRequestDto, options: options });
    }

    /**
     * HTTP GET /financial-service-provider/pricelist/get-all
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.getAll
     */
    getAll$GET$financialserviceprovider_pricelist_getall(options?: O): RestResponse<WebResponseEntity<GetAllPricelistsResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`financial-service-provider/pricelist/get-all`, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/pricelist/get-filtered
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.getFiltered
     */
    getFiltered(getFilteredPricelistsRequestDto: GetFilteredPricelistsRequestDto, options?: O): RestResponse<WebResponseEntity<GetFilteredPricelistsResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/pricelist/get-filtered`, data: getFilteredPricelistsRequestDto, options: options });
    }

    /**
     * HTTP GET /financial-service-provider/pricelist/get/{ID}
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.getPricelist
     */
    getPricelist(ID: string, options?: O): RestResponse<WebResponseEntity<GetPricelistResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`financial-service-provider/pricelist/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/pricelist/hard-delete
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.hardDeletePricelist
     */
    hardDeletePricelist(hardDeletePricelistRequestDto: HardDeletePricelistRequestDto, options?: O): RestResponse<WebResponseEntity<any>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/pricelist/hard-delete`, data: hardDeletePricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/pricelist/soft-delete
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.softDelete
     */
    softDelete(softDeletePricelistRequestDto: SoftDeletePricelistRequestDto, options?: O): RestResponse<WebResponseEntity<any>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/pricelist/soft-delete`, data: softDeletePricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/pricelist/update
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.updatePricelist
     */
    updatePricelist(updatePricelistRequestDto: UpdatePricelistRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/pricelist/update`, data: updatePricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/pricelist/update-pricelist-definition
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.updatePricelistDefinition
     */
    updatePricelistDefinition(updatePricelistDefinitionDto: UpdatePricelistDefinitionDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/pricelist/update-pricelist-definition`, data: updatePricelistDefinitionDto, options: options });
    }

    /**
     * HTTP POST /financial-service-provider/pricelist/update-pricelist-items
     * Java method: com.europoint.financialserviceprovider.web.controllers.PricelistMasterAgentController.updatePricelistItems
     */
    updatePricelistItems(updatePricelistItemsRequestDto: UpdatePricelistItemsRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`financial-service-provider/pricelist/update-pricelist-items`, data: updatePricelistItemsRequestDto, options: options });
    }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

export type DateAsString = string;

/**
 * Values:
 * - `CONTINUE`
 * - `SWITCHING_PROTOCOLS`
 * - `PROCESSING`
 * - `CHECKPOINT`
 * - `OK`
 * - `CREATED`
 * - `ACCEPTED`
 * - `NON_AUTHORITATIVE_INFORMATION`
 * - `NO_CONTENT`
 * - `RESET_CONTENT`
 * - `PARTIAL_CONTENT`
 * - `MULTI_STATUS`
 * - `ALREADY_REPORTED`
 * - `IM_USED`
 * - `MULTIPLE_CHOICES`
 * - `MOVED_PERMANENTLY`
 * - `FOUND`
 * - `MOVED_TEMPORARILY` - @deprecated
 * - `SEE_OTHER`
 * - `NOT_MODIFIED`
 * - `USE_PROXY` - @deprecated
 * - `TEMPORARY_REDIRECT`
 * - `PERMANENT_REDIRECT`
 * - `BAD_REQUEST`
 * - `UNAUTHORIZED`
 * - `PAYMENT_REQUIRED`
 * - `FORBIDDEN`
 * - `NOT_FOUND`
 * - `METHOD_NOT_ALLOWED`
 * - `NOT_ACCEPTABLE`
 * - `PROXY_AUTHENTICATION_REQUIRED`
 * - `REQUEST_TIMEOUT`
 * - `CONFLICT`
 * - `GONE`
 * - `LENGTH_REQUIRED`
 * - `PRECONDITION_FAILED`
 * - `PAYLOAD_TOO_LARGE`
 * - `REQUEST_ENTITY_TOO_LARGE` - @deprecated
 * - `URI_TOO_LONG`
 * - `REQUEST_URI_TOO_LONG` - @deprecated
 * - `UNSUPPORTED_MEDIA_TYPE`
 * - `REQUESTED_RANGE_NOT_SATISFIABLE`
 * - `EXPECTATION_FAILED`
 * - `I_AM_A_TEAPOT`
 * - `INSUFFICIENT_SPACE_ON_RESOURCE` - @deprecated
 * - `METHOD_FAILURE` - @deprecated
 * - `DESTINATION_LOCKED` - @deprecated
 * - `UNPROCESSABLE_ENTITY`
 * - `LOCKED`
 * - `FAILED_DEPENDENCY`
 * - `TOO_EARLY`
 * - `UPGRADE_REQUIRED`
 * - `PRECONDITION_REQUIRED`
 * - `TOO_MANY_REQUESTS`
 * - `REQUEST_HEADER_FIELDS_TOO_LARGE`
 * - `UNAVAILABLE_FOR_LEGAL_REASONS`
 * - `INTERNAL_SERVER_ERROR`
 * - `NOT_IMPLEMENTED`
 * - `BAD_GATEWAY`
 * - `SERVICE_UNAVAILABLE`
 * - `GATEWAY_TIMEOUT`
 * - `HTTP_VERSION_NOT_SUPPORTED`
 * - `VARIANT_ALSO_NEGOTIATES`
 * - `INSUFFICIENT_STORAGE`
 * - `LOOP_DETECTED`
 * - `BANDWIDTH_LIMIT_EXCEEDED`
 * - `NOT_EXTENDED`
 * - `NETWORK_AUTHENTICATION_REQUIRED`
 */
export const enum HttpStatus {
    CONTINUE = "CONTINUE",
    SWITCHING_PROTOCOLS = "SWITCHING_PROTOCOLS",
    PROCESSING = "PROCESSING",
    CHECKPOINT = "CHECKPOINT",
    OK = "OK",
    CREATED = "CREATED",
    ACCEPTED = "ACCEPTED",
    NON_AUTHORITATIVE_INFORMATION = "NON_AUTHORITATIVE_INFORMATION",
    NO_CONTENT = "NO_CONTENT",
    RESET_CONTENT = "RESET_CONTENT",
    PARTIAL_CONTENT = "PARTIAL_CONTENT",
    MULTI_STATUS = "MULTI_STATUS",
    ALREADY_REPORTED = "ALREADY_REPORTED",
    IM_USED = "IM_USED",
    MULTIPLE_CHOICES = "MULTIPLE_CHOICES",
    MOVED_PERMANENTLY = "MOVED_PERMANENTLY",
    FOUND = "FOUND",
    /**
     * @deprecated
     */
    MOVED_TEMPORARILY = "MOVED_TEMPORARILY",
    SEE_OTHER = "SEE_OTHER",
    NOT_MODIFIED = "NOT_MODIFIED",
    /**
     * @deprecated
     */
    USE_PROXY = "USE_PROXY",
    TEMPORARY_REDIRECT = "TEMPORARY_REDIRECT",
    PERMANENT_REDIRECT = "PERMANENT_REDIRECT",
    BAD_REQUEST = "BAD_REQUEST",
    UNAUTHORIZED = "UNAUTHORIZED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    FORBIDDEN = "FORBIDDEN",
    NOT_FOUND = "NOT_FOUND",
    METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED",
    NOT_ACCEPTABLE = "NOT_ACCEPTABLE",
    PROXY_AUTHENTICATION_REQUIRED = "PROXY_AUTHENTICATION_REQUIRED",
    REQUEST_TIMEOUT = "REQUEST_TIMEOUT",
    CONFLICT = "CONFLICT",
    GONE = "GONE",
    LENGTH_REQUIRED = "LENGTH_REQUIRED",
    PRECONDITION_FAILED = "PRECONDITION_FAILED",
    PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE",
    /**
     * @deprecated
     */
    REQUEST_ENTITY_TOO_LARGE = "REQUEST_ENTITY_TOO_LARGE",
    URI_TOO_LONG = "URI_TOO_LONG",
    /**
     * @deprecated
     */
    REQUEST_URI_TOO_LONG = "REQUEST_URI_TOO_LONG",
    UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
    REQUESTED_RANGE_NOT_SATISFIABLE = "REQUESTED_RANGE_NOT_SATISFIABLE",
    EXPECTATION_FAILED = "EXPECTATION_FAILED",
    I_AM_A_TEAPOT = "I_AM_A_TEAPOT",
    /**
     * @deprecated
     */
    INSUFFICIENT_SPACE_ON_RESOURCE = "INSUFFICIENT_SPACE_ON_RESOURCE",
    /**
     * @deprecated
     */
    METHOD_FAILURE = "METHOD_FAILURE",
    /**
     * @deprecated
     */
    DESTINATION_LOCKED = "DESTINATION_LOCKED",
    UNPROCESSABLE_ENTITY = "UNPROCESSABLE_ENTITY",
    LOCKED = "LOCKED",
    FAILED_DEPENDENCY = "FAILED_DEPENDENCY",
    TOO_EARLY = "TOO_EARLY",
    UPGRADE_REQUIRED = "UPGRADE_REQUIRED",
    PRECONDITION_REQUIRED = "PRECONDITION_REQUIRED",
    TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
    REQUEST_HEADER_FIELDS_TOO_LARGE = "REQUEST_HEADER_FIELDS_TOO_LARGE",
    UNAVAILABLE_FOR_LEGAL_REASONS = "UNAVAILABLE_FOR_LEGAL_REASONS",
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
    NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
    BAD_GATEWAY = "BAD_GATEWAY",
    SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
    GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT",
    HTTP_VERSION_NOT_SUPPORTED = "HTTP_VERSION_NOT_SUPPORTED",
    VARIANT_ALSO_NEGOTIATES = "VARIANT_ALSO_NEGOTIATES",
    INSUFFICIENT_STORAGE = "INSUFFICIENT_STORAGE",
    LOOP_DETECTED = "LOOP_DETECTED",
    BANDWIDTH_LIMIT_EXCEEDED = "BANDWIDTH_LIMIT_EXCEEDED",
    NOT_EXTENDED = "NOT_EXTENDED",
    NETWORK_AUTHENTICATION_REQUIRED = "NETWORK_AUTHENTICATION_REQUIRED",
}

export const enum AccountType {
    TRANSACTIONAL = "TRANSACTIONAL",
    PURPOSE = "PURPOSE",
    SPECIAL = "SPECIAL",
    REGULAR = "REGULAR",
    SAVINGS = "SAVINGS",
    CREDIT = "CREDIT",
}

export const enum AccountStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
    CLOSED = "CLOSED",
}

export const enum PricelistType {
    GENERAL = "GENERAL",
    FOR_AGENT = "FOR_AGENT",
    FOR_LOCATION = "FOR_LOCATION",
    FOR_BANK = "FOR_BANK",
}

export const enum PricelistStateType {
    CREATING = "CREATING",
    SETTING_DEFINITION = "SETTING_DEFINITION",
    FORMING = "FORMING",
    PREPARED = "PREPARED",
    VERIFIED = "VERIFIED",
    REJECTED = "REJECTED",
    ACTIVATED = "ACTIVATED",
    DEACTIVATED = "DEACTIVATED",
    CLOSED = "CLOSED",
    DELETED = "DELETED",
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// Added by 'AxiosClientExtension' extension

import axios from "axios";
import * as Axios from "axios";

declare module "axios" {
    export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
        data: R;
    }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {

    constructor(private axios: Axios.AxiosInstance) {
    }

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Axios.AxiosRequestConfig; }): RestResponse<R> {
        function assign(target: any, source?: any) {
            if (source != undefined) {
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        }

        const config: Axios.AxiosRequestConfig = {};
        config.method = requestConfig.method as typeof config.method;  // `string` in axios 0.16.0, `Method` in axios 0.19.0
        config.url = requestConfig.url;
        config.params = requestConfig.queryParams;
        config.data = requestConfig.data;
        assign(config, requestConfig.options);
        const copyFn = requestConfig.copyFn;

        const axiosResponse = this.axios.request(config);
        return axiosResponse.then(axiosResponse => {
            if (copyFn && axiosResponse.data) {
                (axiosResponse as any).originalData = axiosResponse.data;
                axiosResponse.data = copyFn(axiosResponse.data);
            }
            return axiosResponse;
        });
    }
}

export class AxiosRestApplicationClient extends RestApplicationClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}
